import { Calendar } from 'lucide-react';
import { Card } from '@/components/Card';
import { StatusBadge } from '@/components/StatusBadge';
import { useApi } from '@/hooks/useApi';

interface Interview {
  id: string;
  type: string;
  scheduled_at: string;
  duration_minutes: number;
  interviewer_names: string[];
  candidate_id: string;
  candidate_name: string;
  job_title: string;
  result?: string;
  location?: string;
  meeting_url?: string;
}

export function InterviewsPage() {
  const { data, loading } = useApi<{ interviews: Interview[] }>('interviews');

  if (loading) return <div className="text-muted-foreground">Loading...</div>;

  return (
    <div className="space-y-4">
      <h2 className="text-lg font-semibold text-foreground flex items-center gap-2">
        <Calendar className="w-5 h-5 text-amber-500" /> Upcoming Interviews
      </h2>
      {(data?.interviews ?? []).length === 0 ? (
        <Card><p className="text-sm text-muted-foreground">No upcoming interviews scheduled</p></Card>
      ) : (
        <div className="space-y-3">
          {data?.interviews.map(i => (
            <Card key={i.id}>
              <div className="flex items-center justify-between">
                <div>
                  <p className="text-sm font-medium text-foreground">{i.candidate_name}</p>
                  <p className="text-xs text-muted-foreground">{i.job_title} &middot; {i.type} interview &middot; {i.duration_minutes}min</p>
                  <p className="text-xs text-muted-foreground mt-1">Interviewers: {i.interviewer_names.join(', ') || 'TBD'}</p>
                </div>
                <div className="text-right">
                  <p className="text-sm text-foreground">{new Date(i.scheduled_at).toLocaleDateString()}</p>
                  <p className="text-xs text-muted-foreground">{new Date(i.scheduled_at).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}</p>
                  {i.result && <StatusBadge status={i.result} className="mt-1" />}
                </div>
              </div>
            </Card>
          ))}
        </div>
      )}
    </div>
  );
}
